import 'uni-pages';import 'uni-h5';import App from './App'
import uView from "uview-ui";

import Vue from 'vue'


import '@/static/js/uni.webview.1.5.4'

import VueClipBoard from 'vue-clipboard2'

import {
	baseUrl
} from "@/config.js"
/** url配置 */
Vue.prototype.apiUrl = baseUrl
/** end */
Vue.mixin({
	methods: {

		setData: function(obj, callback) {
			let that = this;
			let keys = [];
			let val, data;
			Object.keys(obj).forEach(function(key) {
				keys = key.split('.');
				val = obj[key];
				data = that.$data;
				keys.forEach(function(key2, index) {
					if (index + 1 == keys.length) {
						that.$set(data, key2, val);
					} else {
						if (!data[key2]) {
							that.$set(data, key2, {});
						}
					}
					data = data[key2];
				})
			});
			callback && callback();
		},
		isWx: function() {




			var ua = window.navigator.userAgent.toLowerCase();
			//console.log(ua); //mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) 
			// applewebkit / 601.1 .46(khtml, like gecko) version / 9.0 mobile / 13 b143 safari / 601.1
			if (ua.match(/MicroMessenger/i) == 'micromessenger') {
				return true; // 微信中打开
			} else {
				return false; // 普通浏览器中打开
			}

		},
		arrayToObject: function(arr, key = 'area') {
			var obj = {};
			for (var i = 0; i < arr.length; i++) {
				obj[arr[i][key]] = arr[i];
			}
			return obj;
		},
		//保存二维码到相册
		saveQrcode(urlobj) {




































			var arr = urlobj.split(',');
			var bytes = atob(arr[1]);
			let ab = new ArrayBuffer(bytes.length);
			let ia = new Uint8Array(ab);
			for (let i = 0; i < bytes.length; i++) {
				ia[i] = bytes.charCodeAt(i);
			}
			var blob = new Blob([ab], {
				type: 'application/octet-stream'
			});
			var url = URL.createObjectURL(blob);
			var a = document.createElement('a');
			a.href = url;
			a.download = new Date().valueOf() + ".png";
			var e = document.createEvent('MouseEvents');
			e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
			a.dispatchEvent(e);
			URL.revokeObjectURL(url);

		},
	}
});
Vue.use(uView);
Vue.use(VueClipBoard)

Vue.config.productionTip = false
App.mpType = 'app'
const app = new Vue({
	...App
})
app.$mount()












